import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  // eslint-disable-next-line
  async getCoachConfig({}) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/coach",
        method: "GET",
      });

      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async executeActionGeneratorTasks({}, { agents }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/coach/actions/generator-tasks",
        method: "POST",
        data: { agents },
      });

      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async generateCoachTasks({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/coach/tasks",
        method: "POST",
      });

      commit(MutationsType.SET_COACH_TASKS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllCoachTasks({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/coach/tasks",
        method: "GET",
      });

      commit(MutationsType.SET_COACH_TASKS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllCoachTaskTickets({ commit }, { id }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/coach/tasks/${id}/tickets`,
        method: "GET",
        params: { status: "progress" },
      });

      commit(MutationsType.SET_COACH_TASK_TICKETS, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async resetTaskTickets({ commit }) {
    commit(MutationsType.SET_COACH_TASK_TICKETS, null);
  },
  async verifyCoachTaskTicket({ commit }, { id, ticketId }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/coach/tasks/${id}/tickets/${ticketId}/verify`,
        method: "POST",
      });

      commit(MutationsType.UPDATE_COACH_TASK, response.data.data);
      commit(MutationsType.REMOVE_COACH_TASK_TICKET, { id: ticketId });
    } catch (error) {
      throw error.response.data;
    }
  },
};
